module.exports = "/chat-a232aee96d97badbacef4bf2da277ab4.svg";